/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=47a62f8c&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=47a62f8c&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户四川护理-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a62f8c"]])

export default __exports__